import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Text, Stack, Cluster, Icon } from '@iqueue/iq-ui';
import Field from '../components/ui/Field';
import { api } from '../lib/api';
import AuthLayout from './AuthLayout';



export default function RegisterPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setError('');
    if (password !== confirm) { setError('Пароли не совпадают'); return; }
    if (password.length < 8) { setError('Пароль слишком короткий (минимум 8 символов)'); return; }
    setBusy(true);
    try {
      await api.register(username, password);
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <AuthLayout title="Регистрация">
        <Stack gap="var(--md-sys-spacing-200)" >
          <Cluster gap={100} align="center" wrap={false}>
            <Icon name="check_circle" />
            <Text variant="body-large" render={<span />}>Заявка отправлена</Text>
          </Cluster>
          <Text variant="body-medium" muted>Аккаунт станет активным после подтверждения администратором.</Text>
          <Button variant="text" startIcon={<Icon name="arrow_back" />} render={<Link to="/login" />}>К входу</Button>
        </Stack>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Регистрация"
      footer={<span>Уже есть аккаунт? <Link to="/login">Войти</Link></span>}
    >
      <Stack gap={200} render={<form onSubmit={submit} />}>
          <Field label="Имя пользователя" value={username} onChange={setUsername} autoFocus required autoComplete="username" />
          <Field label="Пароль (мин. 8 символов)" type="password" value={password} onChange={setPassword} required autoComplete="new-password" />
          <Field label="Повторите пароль" type="password" value={confirm} onChange={setConfirm} required autoComplete="new-password" />
          {error && <Text variant="body-small" >{error}</Text>}
          <Button type="submit" disabled={busy || !username || !password || !confirm} >
            {busy ? 'Отправка…' : 'Зарегистрироваться'}
          </Button>
      </Stack>
    </AuthLayout>
  );
}
